import { __makeTemplateObject } from "tslib";
import React from 'react';
import { css, flexCenterStyle, radius, typography, } from '../../../foundation';
import { RcAlertClasses, RcAlertColors, RcAlertSpacings } from '../utils';
var textColor = function (_a) {
    var severity = _a.severity;
    return RcAlertColors[severity].text;
};
var backgroundColor = function (_a) {
    var severity = _a.severity;
    return RcAlertColors[severity].background;
};
var rootSpacing = function (_a) {
    var size = _a.size;
    return RcAlertSpacings[size];
};
export var EmptyIcon = React.createElement(React.Fragment, null);
export var AlertStyle = function (_a) {
    var align = _a.align, square = _a.square, icon = _a.icon;
    var isEmpty = icon === undefined;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &.", " {\n      background-color: ", ";\n      display: flex;\n      padding: ", ";\n      word-break: break-word;\n      border-radius: ", ";\n    }\n\n    .", " {\n      ", ";\n      color: ", ";\n      text-align: ", ";\n      flex: 1 1 auto;\n      padding: 0;\n    }\n\n    .", " {\n      ", ";\n      ", ";\n      padding: 0;\n    }\n  "], ["\n    &.", " {\n      background-color: ", ";\n      display: flex;\n      padding: ", ";\n      word-break: break-word;\n      border-radius: ", ";\n    }\n\n    .", " {\n      ", ";\n      color: ", ";\n      text-align: ", ";\n      flex: 1 1 auto;\n      padding: 0;\n    }\n\n    .", " {\n      ", ";\n      ", ";\n      padding: 0;\n    }\n  "])), RcAlertClasses.root, backgroundColor, rootSpacing, square && radius('zero'), RcAlertClasses.message, typography('body1'), textColor, align, RcAlertClasses.icon, flexCenterStyle, isEmpty && "margin: 0");
};
var templateObject_1;
